import React from 'react';
import styles from './LoadingSpinner.module.css';

type Props = {};

const LoadingSpinner = (props: Props) => {
  return (
    <div className={styles.spinnerContainer}>
      <svg className={styles.spinner} viewBox="0 0 50 50">
        <circle
          className={styles.path}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
